<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Novo Vídeo</h3>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-4">
                            <label for="name">Nome</label>
                            <input type="text" class="form-control" name="name" v-model="video.name" id="name" placeholder="Nome">
                        </div>

                        <div class="col-md-4">
                            <label for="category">Categoria do Vídeo</label>
                            <select name="category_video_id" v-model="video.category_video_id" class="form-control" id="category">
                                <option value="">Selecione uma Opção</option>
                                <option v-for="category in categories" :value="category.id" :selected="video.category_video_id == category.id">{{ category.name }}</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            <label for="url">URL do Vídeo</label>
                            <input type="text" class="form-control" name="url" v-model="video.url" id="url" placeholder="URL">
                        </div>
                    </div>

                    <hr>

                    <!-- <input type="submit" class="btn btn-success" value="salvar" v-on="click: onClick"> -->
                    <a class="btn btn-success" @click="save">Salvar</a>
                    <router-link to="/video" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      video: {
        name: "",
        category_video_id: "",
        url: ""
      },
      categories: [],
      errors: undefined
    };
  },
  mounted: function() {
    this.getCategories();
    this.videoInformation();
  },
  methods: {
    save: function() {
      const self = this;
      let id = self.$route.params.id;
      const api = self.$store.state.api + "video/" + id;

      let form = new FormData();

      form.append("name", self.video.name);
      form.append("category_video_id", self.video.category_video_id);
      form.append("url", self.video.url);

      self.$http
        .post(api, form)
        .then(response => {
          self.$message("Sucesso", `Vídeo atualizado com sucesso`, "success");
        })
        .catch(error => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function(key, value) {
              html += '<li class="m-t-sm m-b-sm">' + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    getCategories: function() {
      const self = this;
      const api = self.$store.state.api + "categoryVideo";

      self.$http
        .get(api)
        .then(response => {
          self.categories = response.data.data;
        })
        .catch(error => {
          self.errors = error.response.data.errors;
          self.$message(
            "Erro",
            "Ocorreu um erro ao buscar as Informações da Categoria do Vídeo",
            "error"
          );
        });
    },
    videoInformation: function() {
      const self = this;
      let id = self.$route.params.id;
      const api = self.$store.state.api + "video/" + id;

      self.$http
        .get(api)
        .then(response => {
          self.video = response.data;
        })
        .catch(error => {
          self.$message(
            "Erro",
            "Ocorreu um erro ao buscar as informações do Vídeo",
            "error"
          );
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Video/Edit.vue